module.exports = __webpack_public_path__ + "img/phone.7399be07.svg";